export default "__VITE_ASSET__CEng3X0Q__"